import * as documentationContractTypes from 'constants/enums/documentationContractTypes'

export default {
  [documentationContractTypes.RESERVATION_AGREEMENT]: 'Rezervační smlouva',
  [documentationContractTypes.CONTRACT_FOR_A_FUTURE_PURCHASE_AGREEMENT]:
    'Smlouva o smlouvě budoucí kupní',
  [documentationContractTypes.PURCHASE_AGREEMENT]: 'Kupní smlouva',
} as const
